import React from 'react'
import { Form } from 'redux-form/immutable'
import { Redirect } from 'react-router-dom'

import './styles.scss'
const bc = 'profile-form-wrapper'

export const FormWrapper = ({ children, footer, handleSubmit, location: { pathname }, match, isMobile }) => {
  if (pathname === '/profile') {
    if (isMobile) {
      return null
    }
    return <Redirect from={match.path} to={`${match.path}/general`} exact />
  }
  return (
    <div className={`${bc}__content`}>
      {['/profile/notifications', '/profile/active-protracks'].includes(pathname) ? (
        children
      ) : (
        <Form onSubmit={handleSubmit}>
          {children}
          {pathname !== '/profile/active-protracks' && footer}
        </Form>
      )}
    </div>
  )
}
